/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function() {
	return {
		init: function(model/*, spec, boardModel, logger*/) {
			model.on('change:transition', model.boardModel.onLayoutChange, model.boardModel);
		}
	};
});
